import * as api from '../api/properties.js';
import q from '../query.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const propertiesEntity = 'properties';
export const propertyTypesEntity = 'property-types';
export const propertyTypesKey = `property-types`;
export const usePropertyTypes = () => q.query(propertyTypesKey, () => api.getTypes(), keys.read.collection(propertyTypesEntity));
export const propertiesKey = (ref, refId, scope, scopeId) => `properties-${ref}-${refId}-${scope || null}-${scopeId || null}`;
export const useProperties = (ref, refId, scope, scopeId) => q.query(propertiesKey(ref, refId, scope, scopeId), () => api.get({
    ref: ref,
    refId: refId,
    scope: scope || null,
    scopeId: scopeId || null,
}), keys.read.collection(propertiesEntity));
//# sourceMappingURL=index.js.map